import { Col }                 from 'antd';
import { Input }               from 'antd';
import { Form }                from 'antd';
import YesOrNo                 from 'components/App/YesOrNo';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import Row                     from 'components/App/Row';

const StepStand = () => (
  <div className="new-modal-form">
    <Row>
      <Col lg={12} md={12} sm={12} xl={12} xs={24}>
        <Form.Item
          label={<FormattedMessageWrapper id="Enseigne" />}
          labelCol={{ span: 24 }}
          name="name"
          rules={[
            {
              message: <FormattedMessageWrapper id="Information manquante" />,
              required: true,
            },
          ]}
        >
          <Input placeholder="Enseigne" />
        </Form.Item>
      </Col>
      <Col lg={12} md={12} sm={12} xl={12} xs={24}>
        <Form.Item
          label={<FormattedMessageWrapper id="Type de stand" />}
          labelCol={{ span: 24 }}
          name="standType"
          rules={[
            {
              message: <FormattedMessageWrapper id="Information manquante" />,
              required: true,
            },
          ]}
        >
          <Input placeholder="Type de stand" />
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col lg={6} md={6} sm={6} xl={6} xs={24}>
        <Form.Item
          label={<FormattedMessageWrapper id="Hall" />}
          labelCol={{ span: 24 }}
          name="hall"
          rules={[
            {
              message: <FormattedMessageWrapper id="Information manquante" />,
              required: true,
            },
          ]}
        >
          <Input placeholder="Hall" />
        </Form.Item>
      </Col>
      <Col lg={6} md={6} sm={6} xl={6} xs={24}>
        <Form.Item
          label={<FormattedMessageWrapper id="Allée" />}
          labelCol={{ span: 24 }}
          name="aisle"
          rules={[
            {
              message: <FormattedMessageWrapper id="Information manquante" />,
              required: true,
            },
          ]}
        >
          <Input placeholder="Allée" />
        </Form.Item>
      </Col>
      <Col lg={6} md={6} sm={6} xl={6} xs={24}>
        <Form.Item
          label={<FormattedMessageWrapper id="Numéro" />}
          labelCol={{ span: 24 }}
          name="number"
          rules={[
            {
              message: <FormattedMessageWrapper id="Information manquante" />,
              required: true,
            },
          ]}
        >
          <Input placeholder="Numéro" />
        </Form.Item>
      </Col>
      <Col lg={6} md={6} sm={6} xl={6} xs={24}>
        <Form.Item
          label={<FormattedMessageWrapper id="Surface" />}
          labelCol={{ span: 24 }}
          name="surface"
          rules={[
            {
              message: <FormattedMessageWrapper id="Information manquante" />,
              required: true,
            },
          ]}
        >
          <Input placeholder="Surface" />
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col xs={24}>
        <Form.Item
          label={
            <FormattedMessageWrapper id="Souhaitez-vous notifier les exposants pour demander les plans ?" />
          }
          labelCol={{ span: 24 }}
          name="openNotificationModal"
          rules={[
            {
              message: <FormattedMessageWrapper id="Information manquante" />,
              required: true,
            },
          ]}
        >
          <YesOrNo />
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col xs={24}>
        <small>
          <FormattedMessageWrapper id="Enregistrer le stand pour pouvoir saisir les informations de l'agence et du décorateur." />
        </small>
      </Col>
    </Row>
  </div>
);

export default StepStand;
